import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { FormattedMessage, FormattedPlural } from 'react-intl'
import { InputDate } from 'components/fields'
import { InfoPanel } from 'components/misc'
import { Title } from 'components/layout'
import { AJ_EVENT_TYPES, LEVELS, AJ_MIN_DATES } from 'constants/enums'

export default class AJEventDates extends Component {
  static propTypes = {
    values: PropTypes.object
  }

  render() {
    const { values } = this.props

    let minDays = 2

    let minNights = 1

    let translatedName = null

    const isQualifying =
      get(values, 'ajEventCategory.value') === AJ_EVENT_TYPES.qualification.id

    switch (get(values, 'awardLevel.value')) {
      case LEVELS.BRONZE.value:
        minDays = AJ_MIN_DATES.bronze.days
        minNights = AJ_MIN_DATES.bronze.nights
        translatedName = (
          <FormattedMessage
            id="award.bronze_level"
            defaultMessage="Bronze level"
          />
        )
        break
      case LEVELS.SILVER.value:
        minDays = AJ_MIN_DATES.silver.days
        minNights = AJ_MIN_DATES.silver.nights
        translatedName = (
          <FormattedMessage
            id="award.silver_level"
            defaultMessage="Silver level"
          />
        )
        break
      case LEVELS.GOLD.value:
        minDays = AJ_MIN_DATES.gold.days
        minNights = AJ_MIN_DATES.gold.nights
        translatedName = (
          <FormattedMessage id="award.gold_level" defaultMessage="Gold level" />
        )
        break

      default:
        minDays = AJ_MIN_DATES.bronze.days
        minNights = AJ_MIN_DATES.bronze.nights
    }

    let message = (
      <FormattedMessage
        id="aj.minimum_date_recommendation"
        defaultMessage="Minimum date recommendation for Practice AJ and {name} is"
        values={{
          name: translatedName
        }}
      />
    )

    if (isQualifying) {
      message = (
        <FormattedMessage
          id="aj.minimum_date_requirements"
          defaultMessage="Minimum date requirement for Qualifying AJ and {name} is"
          values={{
            name: translatedName
          }}
        />
      )
    }

    const oneDay = <FormattedMessage id="global.day" />
    const moreDays = <FormattedMessage id="global.days" />
    const oneNight = <FormattedMessage id="global.night" />
    const moreNights = <FormattedMessage id="global.nights" />

    return (
      <div className="row">
        <div className="col-xs-12">
          <Title h2 intlKey="moduleTitle.dates">
            Dates
          </Title>
        </div>
        <div className="col-xs-6">
          <InputDate
            label="Journey start date"
            intlKey="label.start_date"
            name="startDate"
          />
        </div>
        <div className="col-xs-6">
          <InputDate
            label="Journey end date"
            intlKey="label.end_date"
            name="endDate"
          />
        </div>
        <div className="col-xs-12">
          {isQualifying &&
            get(values, 'awardLevel.value') && (
              <InfoPanel neutral>
                {message} {minDays}{' '}
                {
                  <FormattedPlural
                    value={minDays}
                    one={oneDay}
                    other={moreDays}
                  />
                }{' '}
                / {minNights}{' '}
                {
                  <FormattedPlural
                    value={minNights}
                    one={oneNight}
                    other={moreNights}
                  />
                }
              </InfoPanel>
            )}
        </div>
      </div>
    )
  }
}
